export type TNativeScriptProcessorNode = ScriptProcessorNode; // tslint:disable-line:deprecation
